/* 123custom product designer bridge (product template only)
   The designer is a FULL-PAGE REDIRECT to the same-origin app proxy
   (/apps/design -> Vercel /embed) which hands the finished design back via
   cd_* query params on return_url (see docs/OVERVIEW.md section 1). This file
   owns: Personalise -> designer URL, the pack/bundle slot grid (progress
   persisted across the round trip), return finalisation (cart-edit / pack
   resume + submit) and "add to cart, design later". Liquid-injected values
   arrive through the <script type="application/json" data-product-designer-config>
   block rendered by sections/main-product.liquid. */
(function () {
  var configEl = document.querySelector('[data-product-designer-config]');
  if (!configEl) return;
  var legacyEditUrl = new URL(window.location.href);
  if (document.querySelector('[data-legacy-engraving]') && legacyEditUrl.searchParams.get('line_key')
    && legacyEditUrl.searchParams.get('customize') !== '1' && legacyEditUrl.hash === '#engraving-panel') return;
  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (error) {
    return;
  }
  var DESIGNER_PATH = '/apps/design';
  var MAX_PACK_SLOTS = 250;
  var MAX_INDIVIDUAL_DESIGNS = 25;
  var productId    = String(config.productId);
  var productUrl   = config.productUrl;
  var productHandle = config.productHandle;
  var productType  = config.productType;
  var suiteKey     = config.suiteKey;
  var IS_ENGRAVING = /^engraved-/.test(suiteKey || '');
  var modelKey     = config.modelKey;
  var ITEM_NOUN    = config.itemNoun;
  var ITEM_NOUN_PLURAL = config.itemNounPlural;
  function capitalize(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
  var printAreaWidth = config.printAreaWidth;
  var printAreaHeight = config.printAreaHeight;
  var printAreaUnit = config.printAreaUnit;
  // Per-variant suite + dimensions, used so products whose variants
  // differ in shape (e.g. coaster square vs round) pick the right
  // suite for the variant the shopper has selected.
  var VARIANT_SUITES = config.variantSuites || {};
  var firstVariantId = String(config.firstVariantId || '');
  function getVariantEntry(variantId) {
    if (!variantId) return null;
    return VARIANT_SUITES[String(variantId)] || null;
  }
  function effectiveSuiteFor(variantId) {
    var entry = getVariantEntry(variantId);
    return entry && entry.suite ? entry.suite : suiteKey;
  }
  function effectiveDimsFor(variantId) {
    var entry = getVariantEntry(variantId);
    return {
      w: entry && entry.w ? entry.w : printAreaWidth,
      h: entry && entry.h ? entry.h : printAreaHeight,
      u: entry && entry.u ? entry.u : printAreaUnit
    };
  }
  // ===== Bundle mode (multi-suite packs) =====
  // A bundle product (suiteKey 'bundle-mug-coaster') renders one pack
  // slot per bundled item, and each slot opens the designer with that
  // item's own suite + print area. The variant title picks the coaster
  // shape (round/circle => coaster-round, otherwise coaster-square).
  var IS_BUNDLE = suiteKey === 'bundle-mug-coaster';
  function bundleSlotsFor(variantId) {
    if (!IS_BUNDLE) return null;
    var entry = getVariantEntry(variantId);
    var title = entry && entry.title ? String(entry.title).toLowerCase() : '';
    var coasterSuite = (title.indexOf('round') > -1 || title.indexOf('circle') > -1)
      ? 'coaster-round'
      : 'coaster-square';
    return [
      { suite: 'mug', w: '', h: '', u: 'mm', label: 'Mug' },
      { suite: coasterSuite, w: '91', h: '91', u: 'mm', label: 'Coaster' }
    ];
  }
  function bundleSlotFor(variantId, slotIndex) {
    var slots = bundleSlotsFor(variantId);
    if (!slots || slotIndex === null || slotIndex === undefined || slotIndex < 0) return null;
    return slots[slotIndex % slots.length];
  }
  function packSizeFor(variantId) {
    var bundleSlots = bundleSlotsFor(variantId);
    if (bundleSlots) return bundleSlots.length;
    var entry = getVariantEntry(variantId);
    if (entry && typeof entry.pack === 'number' && entry.pack > 1) {
      return entry.pack;
    }
    if (entry && entry.title) {
      var title = String(entry.title);
      // "Pack of 4", "Set of 6", "Box of 12", "Bundle of 4"
      var m = title.match(/(?:pack|set|bundle|box)\s+of\s+(\d+)/i);
      if (!m) {
        // "4-Pack", "6 Pack", "12pk", "Pack 4"
        m = title.match(/(?:^|\s|\/)(\d+)\s*[-\s]*(?:pack|pk)\b/i)
          || title.match(/(?:pack|pk)\s*[-\s]*(\d+)\b/i);
      }
      if (m) {
        var parsed = parseInt(m[1], 10);
        if (parsed > 1) return parsed;
      }
    }
    return 1;
  }
  var shop         = config.shop;
  var shopName     = config.shopName;
  var pageUrl      = new URL(window.location.href);
  var pageParams   = pageUrl.searchParams;
  var shopLogoUrl  = config.shopLogoUrl || '';

  var wrapper = document.getElementById('custom-designer-wrapper');
  var openBtn = document.getElementById('open-custom-designer');
  var activeDraftKey = '';
  if (wrapper) wrapper.style.display = 'block';

  var packModal = document.createElement('div');
  packModal.className = 'pack-grid-modal';
  packModal.setAttribute('role', 'dialog');
  packModal.setAttribute('aria-modal', 'true');
  packModal.setAttribute('aria-label', 'Customise your pack');
  packModal.innerHTML = ''
    + '<div class="pack-grid-card">'
    +   '<button type="button" class="pack-grid-close" aria-label="Close">&times;</button>'
    +   '<h2 class="pack-grid-title" data-pack-title>Customise your order</h2>'
    +   '<button type="button" class="pack-grid-quick" data-pack-quick hidden>'
    +     '<span class="pack-grid-quick__icon" aria-hidden="true">✦</span>'
    +     '<span class="pack-grid-quick__text">'
    +       '<strong data-pack-quick-title>Same design for all</strong>'
    +       '<span data-pack-quick-sub>Upload one photo. It goes on every item.</span>'
    +     '</span>'
    +     '<span class="pack-grid-quick__arrow" aria-hidden="true">→</span>'
    +   '</button>'
    +   '<button type="button" class="pack-tile__action" data-pack-individual hidden>Different designs</button>'
    +   '<p class="pack-grid-divider" data-pack-divider hidden>Or design each one:</p>'
    +   '<div class="pack-grid-tiles" data-pack-tiles></div>'
    +   '<div class="pack-grid-actions">'
    +     '<span class="pack-grid-actions__hint" data-pack-progress>0 of 0 designed</span>'
    +     '<div class="pack-grid-actions__buttons">'
    +       '<button type="button" class="pack-grid-submit" data-pack-submit disabled>Add to Cart</button>'
    +     '</div>'
    +   '</div>'
    + '</div>';
  document.body.appendChild(packModal);

  var packTilesEl   = packModal.querySelector('[data-pack-tiles]');
  var packTitleEl   = packModal.querySelector('[data-pack-title]');
  var packProgressEl = packModal.querySelector('[data-pack-progress]');
  var packSubmitBtn = packModal.querySelector('[data-pack-submit]');
  var packCloseBtn  = packModal.querySelector('.pack-grid-close');
  var packQuickBtn  = packModal.querySelector('[data-pack-quick]');
  var packQuickTitle = packModal.querySelector('[data-pack-quick-title]');
  var packDivider   = packModal.querySelector('[data-pack-divider]');
  var packIndividualBtn = packModal.querySelector('[data-pack-individual]');

  var savedScrollY = 0;

  function addQueryParam(params, name, value) {
    if (value === null || value === undefined || value === '') return;
    params.push(name + '=' + encodeURIComponent(String(value)));
  }

  function buildDesignerParams(variantId, draftKey, options) {
    var params = [];
    var effSuite = effectiveSuiteFor(variantId);
    var effDims = effectiveDimsFor(variantId);
    // Bundle slots override the suite/dims with the active slot's own
    // item (mug or coaster). Slot context comes from the pack grid or
    // from a cart slot edit (pack_slot param).
    var activeSlotIndex = -1;
    if (cartEdit.active && cartEdit.slot > 0) activeSlotIndex = cartEdit.slot - 1;
    else if (pack.activeIndex >= 0) activeSlotIndex = pack.activeIndex;
    var bundleSlot = bundleSlotFor(variantId, activeSlotIndex);
    if (bundleSlot) {
      effSuite = bundleSlot.suite;
      effDims = { w: bundleSlot.w, h: bundleSlot.h, u: bundleSlot.u };
    }
    addQueryParam(params, 'product_id', productId);
    addQueryParam(params, 'variant_id', variantId);
    addQueryParam(params, 'shop', shop);
    addQueryParam(params, 'shop_name', shopName);
    addQueryParam(params, 'shop_logo', shopLogoUrl);
    addQueryParam(params, 'product_handle', productHandle);
    addQueryParam(params, 'product_type', productType);
    addQueryParam(params, 'suite', effSuite);
    addQueryParam(params, 'suite_key', effSuite);
    addQueryParam(params, 'customization_suite', effSuite);
    addQueryParam(params, 'model', modelKey);
    addQueryParam(params, 'model_key', modelKey);
    addQueryParam(params, 'print_area_width', effDims.w);
    addQueryParam(params, 'print_area_height', effDims.h);
    addQueryParam(params, 'print_area_unit', effDims.u);
    addQueryParam(params, 'draft_key', draftKey);
    // Engraved products pick their finish INSIDE the designer, so it
    // needs the real variant list to map a finish back to a variant.
    try {
      var variantList = Object.keys(VARIANT_SUITES).map(function (id) {
        var entry = VARIANT_SUITES[id] || {};
        return { id: id, title: entry.title || '', available: entry.avail !== false };
      });
      if (IS_ENGRAVING && ((options && options.packFlow && pack.unitSize > 1) || cartEdit.slot > 0)) {
        variantList = variantList.filter(function (variant) { return variant.id === String(variantId); });
      }
      if (variantList.length) addQueryParam(params, 'variants', JSON.stringify(variantList));
    } catch (e) { /* designer falls back to the launch variant */ }
    return params;
  }

  function buildDesignerUrl(variantId, draftKey, options) {
    options = options || {};
    var params = buildDesignerParams(variantId, draftKey, options);
    var retSuite = effectiveSuiteFor(variantId);
    var retDims = effectiveDimsFor(variantId);
    var retActiveSlotIndex = -1;
    if (cartEdit.active && cartEdit.slot > 0) retActiveSlotIndex = cartEdit.slot - 1;
    else if (pack.activeIndex >= 0) retActiveSlotIndex = pack.activeIndex;
    var retBundleSlot = bundleSlotFor(variantId, retActiveSlotIndex);
    if (retBundleSlot) {
      retSuite = retBundleSlot.suite;
      retDims = { w: retBundleSlot.w, h: retBundleSlot.h, u: retBundleSlot.u };
    }
    var lineKey  = options.lineKey || '';
    var packSlot = options.packSlot || '';
    // Fresh single-item designs can return straight to /cart. Pack,
    // bundle, and edit flows still need this product page to resume
    // the grid or merge into an existing cart line.
    var returnPath = (!lineKey && !packSlot && !options.packFlow) ? route('/cart') : productUrl;
    var ret = new URL(window.location.origin + returnPath);
    ret.searchParams.set('cd_return', '1');
    if (variantId) ret.searchParams.set('cd_ctx_variant', String(variantId));
    if (draftKey)  ret.searchParams.set('cd_ctx_draft_key', String(draftKey));
    if (options.originalDraftKey) ret.searchParams.set('cd_ctx_original_draft_key', String(options.originalDraftKey));
    if (retSuite) ret.searchParams.set('cd_ctx_suite', String(retSuite));
    if (modelKey) ret.searchParams.set('cd_ctx_model', String(modelKey));
    if (retDims.w) ret.searchParams.set('cd_ctx_print_width', String(retDims.w));
    if (retDims.h) ret.searchParams.set('cd_ctx_print_height', String(retDims.h));
    if (retDims.u) ret.searchParams.set('cd_ctx_print_unit', String(retDims.u));
    if (lineKey)  ret.searchParams.set('cd_ctx_line_key', String(lineKey));
    if (packSlot) ret.searchParams.set('cd_ctx_pack_slot', String(packSlot));
    if (options.packFlow) {
      ret.searchParams.set('cd_ctx_pack', '1');
      ret.searchParams.set('cd_ctx_pack_mode', String(options.packMode || pack.mode));
      ret.searchParams.set('cd_ctx_pack_unit_size', String(options.packUnitSize || pack.unitSize));
      ret.searchParams.set('cd_ctx_pack_count', String(options.packCount || pack.packCount));
      ret.searchParams.set('cd_ctx_pack_total', String(options.packTotal || pack.size));
    }
    var previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewId) ret.searchParams.set('preview_theme_id', previewId);

    addQueryParam(params, 'return_url', ret.toString());
    addQueryParam(params, 'cart_url', window.location.origin + route('/cart'));
    addQueryParam(params, 'product_url', window.location.origin + productUrl);
    addQueryParam(params, 'line_key', lineKey);
    addQueryParam(params, 'pack_slot', packSlot);
    addQueryParam(params, 'bundle_parent_suite', IS_BUNDLE ? suiteKey : '');
    addQueryParam(params, 'source_draft_key', options.sourceDraftKey || '');
    if (options.packDesignCount > 1) {
      addQueryParam(params, 'pack_design_mode', options.packDesignMode || 'individual');
      addQueryParam(params, 'pack_design_count', options.packDesignCount);
    }
    return route(DESIGNER_PATH) + '?' + params.join('&');
  }

  function buildReopenUrl(variantId, draftKey) {
    return buildDesignerUrl(variantId, draftKey, {});
  }

  function getCurrentVariantId() {
    var sel = document.querySelector('select[name="id"], input[name="id"]:checked, input[name="id"]');
    return sel ? sel.value : firstVariantId;
  }
  function makeDraftKey() {
    var variantId = getCurrentVariantId();
    var randomPart = window.crypto && window.crypto.randomUUID
      ? window.crypto.randomUUID()
      : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);

    return ['draft', productId || 'product', variantId || 'variant', randomPart].join(':');
  }
  function route(path) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root + path.replace(/^\//, '');
  }
  function withPreviewParam(url) {
    var currentSearch = new URLSearchParams(window.location.search);
    var previewId = currentSearch.get('preview_theme_id');
    if (!previewId) return url;
    var separator = url.indexOf('?') > -1 ? '&' : '?';
    return url + separator + 'preview_theme_id=' + encodeURIComponent(previewId);
  }
  function normalizeProperties(properties) {
    var normalized = {};
    if (!properties || typeof properties !== 'object') return normalized;

    Object.keys(properties).forEach(function (key) {
      var value = properties[key];
      if (value === undefined || value === null || value === '') return;
      normalized[key] = typeof value === 'object' ? JSON.stringify(value) : String(value);
    });

    return normalized;
  }
  function parseCartAddError(response) {
    return response.text().then(function (text) {
      var message = 'Cart add failed';
      if (text) {
        try {
          var json = JSON.parse(text);
          message = json.description || json.message || message;
        } catch (error) {
          message = text;
        }
      }
      throw new Error(message);
    });
  }
  function syncVariantSelection(variantId) {
    if (!variantId) return;

    var selects = document.querySelectorAll('select[name="id"], [data-variant-select]');
    selects.forEach(function (selectEl) {
      if (selectEl.value !== variantId) {
        selectEl.value = variantId;
        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    var radios = document.querySelectorAll('input[name="id"]');
    radios.forEach(function (radio) {
      if (radio.value === variantId && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function clearAutoOpenParam() {
    if (!pageParams.get('customize') && !pageParams.get('draft_key')) return;
    pageParams.delete('customize');
    pageParams.delete('draft_key');
    pageParams.delete('suite_key');
    pageParams.delete('pack_slot');
    pageParams.delete('line_key');
    var nextSearch = pageParams.toString();
    window.history.replaceState({}, '', pageUrl.pathname + (nextSearch ? '?' + nextSearch : '') + pageUrl.hash);
  }

  // Cart-edit mode: editing one slot of an existing pack line item.
  var cartEdit = { active: false, lineKey: '', slot: 0 };

  function openDesigner(options) {
    options = options || {};
    var variantId = getCurrentVariantId();
    var nextDraftKey = Object.prototype.hasOwnProperty.call(options, 'draftKey')
      ? options.draftKey
      : activeDraftKey;
    activeDraftKey = nextDraftKey || makeDraftKey();
    window.location.href = buildDesignerUrl(variantId, activeDraftKey, {
      lineKey: options.lineKey || cartEdit.lineKey,
      packSlot: options.packSlot || cartEdit.slot || '',
      packFlow: !!options.packFlow,
      packMode: options.packMode || '',
      packUnitSize: options.packUnitSize || '',
      packCount: options.packCount || '',
      packTotal: options.packTotal || '',
      sourceDraftKey: options.sourceDraftKey || '',
      originalDraftKey: options.originalDraftKey || '',
      packDesignMode: options.packDesignMode || '',
      packDesignCount: options.packDesignCount || 0
    });
  }

  window.openCustomDesigner = function () {
    var variantId = getCurrentVariantId();
    var packN = packSizeFor(variantId);
    var qty = getQuantityValue();
    if (!guardPackSlots(packN, qty)) return;
    // Pack flows keep any saved progress: openPackGrid() restores the slots a
    // shopper already designed (same product, variant, mode and size, within
    // PACK_PROGRESS_MAX_AGE_MS) so a reload mid-pack does not throw them away.
    // Progress for a different context fails validation and is simply ignored.
    if (packN > 1 && qty > 1) {
      openPackGrid(variantId, packN, qty, 'multipack');
    } else if (packN > 1) {
      openPackGrid(variantId, packN, 1, 'pack');
    } else if (qty > 1) {
      openPackGrid(variantId, 1, qty, 'multiqty');
    } else {
      // Single design: a half-finished pack from an earlier round-trip is
      // irrelevant here, so drop it rather than restore it later by surprise.
      clearPackProgress();
      openDesigner({ draftKey: makeDraftKey() });
    }
  };

  // ===== Pack mode (multi-design line items) =====
  var pack = {
    size: 1,        // total number of slots in the grid
    unitSize: 1,    // designs per pack (1 for non-pack products)
    packCount: 1,   // how many packs / units of the variant
    slots: [],
    activeIndex: -1,
    variantId: null,
    quickMode: false,
    designMode: 'individual',
    mode: 'pack'    // 'pack' | 'multiqty' | 'multipack'
  };

  function getQuantityValue() {
    var input = document.querySelector('input[name="quantity"]');
    if (!input) return 1;
    var n = parseInt(input.value, 10);
    return n > 0 ? n : 1;
  }

  function guardPackSlots(unitSize, packCount) {
    var total = unitSize * packCount;
    if (!positivePackInteger(unitSize) || !positivePackInteger(packCount) || !positivePackInteger(total)) {
      alert('This order has too many design slots. Please choose no more than ' + MAX_PACK_SLOTS + ' items in total, or reduce the number of packs.');
      return false;
    }
    return true;
  }

  function guardIndividualDesigns(count) {
    if (count <= MAX_INDIVIDUAL_DESIGNS) return true;
    alert('Different designs are supported for up to ' + MAX_INDIVIDUAL_DESIGNS + ' items per design session. For this ' + count + '-item order, choose Same design on all ' + count + ', or reduce the pack size or quantity before starting.');
    return false;
  }

  function resetPackState(unitSize, packCount, variantId, mode) {
    pack.unitSize = Math.max(1, unitSize);
    pack.packCount = Math.max(1, packCount);
    pack.size = pack.unitSize * pack.packCount;
    pack.slots = [];
    for (var i = 0; i < pack.size; i++) pack.slots.push(null);
    pack.activeIndex = -1;
    pack.variantId = variantId;
    pack.quickMode = false;
    pack.designMode = 'individual';
    pack.mode = mode || 'pack';
  }

  function packFilledCount() {
    var n = 0;
    for (var i = 0; i < pack.slots.length; i++) {
      if (pack.slots[i] && pack.slots[i].draftKey) n++;
    }
    return n;
  }

  function firstFilledSlot() {
    for (var i = 0; i < pack.slots.length; i++) {
      if (pack.slots[i] && pack.slots[i].draftKey) return pack.slots[i];
    }
    return null;
  }

  function renderPackGrid() {
    packTilesEl.innerHTML = '';
    var isMultiPack = pack.mode === 'multipack';
    var bundleSlots = bundleSlotsFor(pack.variantId || getCurrentVariantId());
    var currentGroup = null;
    for (var i = 0; i < pack.size; i++) {
      var slot = pack.slots[i];
      var isFilled = !!(slot && slot.draftKey);

      if (isMultiPack && i % pack.unitSize === 0) {
        var packIndex = Math.floor(i / pack.unitSize);
        var header = document.createElement('div');
        header.className = 'pack-section-header';
        header.textContent = (bundleSlots ? 'Bundle ' : 'Pack ') + (packIndex + 1) + ' of ' + pack.packCount;
        packTilesEl.appendChild(header);
        currentGroup = document.createElement('div');
        currentGroup.className = 'pack-section-tiles';
        packTilesEl.appendChild(currentGroup);
      }

      var tile = document.createElement('div');
      tile.className = 'pack-tile' + (isFilled ? ' is-filled' : '');
      tile.setAttribute('data-pack-slot', String(i));

      var label = document.createElement('div');
      label.className = 'pack-tile__index';
      var nounLabel = capitalize(ITEM_NOUN || 'item');
      if (bundleSlots) {
        label.textContent = bundleSlots[i % bundleSlots.length].label;
      } else if (isMultiPack) {
        var inPackIdx = (i % pack.unitSize) + 1;
        label.textContent = nounLabel + ' ' + inPackIdx;
      } else {
        label.textContent = nounLabel + ' ' + (i + 1);
      }
      tile.appendChild(label);

      if (isFilled) {
        var thumbSrc = slot.productionUrl || slot.previewUrl || '';
        if (thumbSrc) {
          var img = document.createElement('img');
          img.className = 'pack-tile__thumb';
          img.src = thumbSrc;
          img.alt = 'Design for item ' + (i + 1);
          tile.appendChild(img);
        }
        var actions = document.createElement('div');
        actions.className = 'pack-tile__actions';
        var editBtn = document.createElement('button');
        editBtn.type = 'button';
        editBtn.className = 'pack-tile__action';
        editBtn.textContent = hasSharedDraft(i) ? 'Make this one different' : 'Edit';
        editBtn.setAttribute('data-pack-action', 'edit');
        actions.appendChild(editBtn);

        var copyBtn = null;
        if (!bundleSlots) {
          // Copying designs between bundle slots is disabled: each slot
          // is a different product shape (mug artwork won't fit a coaster).
          copyBtn = document.createElement('button');
          copyBtn.type = 'button';
          copyBtn.className = 'pack-tile__action pack-tile__action--copy';
          copyBtn.textContent = 'Copy to…';
          copyBtn.setAttribute('data-pack-action', 'copy-toggle');
          actions.appendChild(copyBtn);
        }
        tile.appendChild(actions);

        var copyMenu = document.createElement('div');
        copyMenu.className = 'pack-tile__copy-menu';
        copyMenu.setAttribute('data-copy-menu', '');
        copyMenu.hidden = true;

        var emptyTargets = [];
        var filledTargets = [];
        for (var t = 0; t < pack.size; t++) {
          if (t === i) continue;
          var targetSlot = pack.slots[t];
          if (targetSlot && targetSlot.draftKey) filledTargets.push(t);
          else emptyTargets.push(t);
        }

        if (emptyTargets.length > 1) {
          var allEmptyBtn = document.createElement('button');
          allEmptyBtn.type = 'button';
          allEmptyBtn.className = 'pack-tile__copy-menu-item pack-tile__copy-menu-item--primary';
          allEmptyBtn.setAttribute('data-pack-action', 'copy-to');
          allEmptyBtn.setAttribute('data-copy-target', 'empty');
          allEmptyBtn.textContent = 'All empty items (' + emptyTargets.length + ')';
          copyMenu.appendChild(allEmptyBtn);
        }
        for (var et = 0; et < emptyTargets.length; et++) {
          var idx = emptyTargets[et];
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'pack-tile__copy-menu-item';
          b.setAttribute('data-pack-action', 'copy-to');
          b.setAttribute('data-copy-target', String(idx));
          b.textContent = 'Item ' + (idx + 1) + ' (empty)';
          copyMenu.appendChild(b);
        }
        for (var ft = 0; ft < filledTargets.length; ft++) {
          var fidx = filledTargets[ft];
          var fb = document.createElement('button');
          fb.type = 'button';
          fb.className = 'pack-tile__copy-menu-item pack-tile__copy-menu-item--overwrite';
          fb.setAttribute('data-pack-action', 'copy-to');
          fb.setAttribute('data-copy-target', String(fidx));
          fb.textContent = 'Item ' + (fidx + 1) + ' (replace)';
          copyMenu.appendChild(fb);
        }
        if (copyBtn) {
          if (copyMenu.children.length === 0) {
            copyBtn.disabled = true;
            copyBtn.title = 'Nothing to copy to';
          } else {
            tile.appendChild(copyMenu);
          }
        }
      } else {
        var addBtn = document.createElement('button');
        addBtn.type = 'button';
        addBtn.className = 'pack-tile__add-btn';
        addBtn.setAttribute('data-pack-action', 'add');
        addBtn.innerHTML = '<span class="pack-tile__plus">+</span><span class="pack-tile__label-empty">Add design</span>';
        tile.appendChild(addBtn);
      }
      (isMultiPack && currentGroup ? currentGroup : packTilesEl).appendChild(tile);
    }

    var filled = packFilledCount();
    if (filled === 0 && bundleSlots) {
      var slotNames = [];
      for (var bn = 0; bn < bundleSlots.length; bn++) slotNames.push(bundleSlots[bn].label.toLowerCase());
      packProgressEl.textContent = 'Design your ' + slotNames.join(' and ');
    } else if (filled === 0) {
      packProgressEl.textContent = 'Pick same-for-all, or design each one';
    } else {
      packProgressEl.textContent = filled + ' of ' + pack.size + ' designed';
    }
    packSubmitBtn.disabled = filled < pack.size;
    var nounP = ITEM_NOUN_PLURAL || 'items';
    if (bundleSlots && pack.mode === 'multipack') {
      packSubmitBtn.textContent = 'Add ' + pack.packCount + ' bundles to cart';
      packTitleEl.textContent = 'Customise your ' + pack.packCount + ' bundles';
    } else if (bundleSlots) {
      packSubmitBtn.textContent = 'Add bundle to cart';
      packTitleEl.textContent = 'Customise your bundle';
    } else if (pack.mode === 'multipack') {
      packSubmitBtn.textContent = 'Add ' + pack.packCount + ' packs to cart';
      packTitleEl.textContent = 'Customise your ' + pack.size + ' ' + nounP + ' (' + pack.packCount + ' packs of ' + pack.unitSize + ')';
    } else if (pack.mode === 'multiqty') {
      packSubmitBtn.textContent = 'Add ' + pack.size + ' ' + nounP + ' to cart';
      packTitleEl.textContent = 'Customise your ' + pack.size + ' ' + nounP;
    } else {
      packSubmitBtn.textContent = 'Add to cart';
      packTitleEl.textContent = 'Customise your ' + pack.size + ' ' + nounP;
    }

    if (pack.size > 1 && !bundleSlots) {
      packQuickBtn.hidden = false;
      packDivider.hidden = false;
      packQuickTitle.textContent = 'Same design on all ' + pack.size;
      packQuickBtn.setAttribute('aria-pressed', String(pack.designMode === 'shared'));
      packIndividualBtn.hidden = false;
      packIndividualBtn.setAttribute('aria-pressed', String(pack.designMode === 'individual'));
    } else {
      packQuickBtn.hidden = true;
      packDivider.hidden = true;
      packIndividualBtn.hidden = true;
    }
  }

  function hasSharedDraft(index) {
    var slot = pack.slots[index];
    return !!(slot && slot.draftKey && pack.slots.some(function (other, i) {
      return i !== index && other && other.draftKey === slot.draftKey;
    }));
  }

  function allSlotsShareDesign() {
    var first = pack.slots[0];
    return !!(first && first.draftKey && pack.slots.every(function (slot) {
      return slot && slot.draftKey === first.draftKey;
    }));
  }

  function copyDesignToTarget(sourceIndex, targetSpec) {
    var src = pack.slots[sourceIndex];
    if (!src || !src.draftKey) return;
    var copyOne = function (i) {
      pack.slots[i] = {
        draftKey: src.draftKey,
        previewUrl: src.previewUrl,
        productionUrl: src.productionUrl,
        variantId: src.variantId || '',
        rawProperties: src.rawProperties
      };
    };
    if (targetSpec === 'empty') {
      for (var i = 0; i < pack.slots.length; i++) {
        if (i === sourceIndex) continue;
        if (!pack.slots[i] || !pack.slots[i].draftKey) copyOne(i);
      }
    } else {
      var t = parseInt(targetSpec, 10);
      if (!isNaN(t) && t >= 0 && t < pack.slots.length && t !== sourceIndex) {
        if (pack.slots[t] && pack.slots[t].draftKey
            && !confirm('Replace the completed design on item ' + (t + 1) + ' with item ' + (sourceIndex + 1) + '?')) return;
        copyOne(t);
      }
    }
    pack.designMode = allSlotsShareDesign() ? 'shared' : 'individual';
    pack.quickMode = false;
    savePackProgress();
    renderPackGrid();
  }

  function closeAllCopyMenus() {
    var menus = packTilesEl.querySelectorAll('[data-copy-menu]');
    for (var i = 0; i < menus.length; i++) menus[i].hidden = true;
  }

  function openPackGrid(variantId, unitSize, packCount, mode) {
    unitSize = Math.max(1, unitSize || 1);
    packCount = Math.max(1, packCount || 1);
    mode = mode || 'pack';
    if (!guardPackSlots(unitSize, packCount)) return;
    if (pack.variantId !== variantId
        || pack.unitSize !== unitSize
        || pack.packCount !== packCount
        || pack.mode !== mode) {
      resetPackState(unitSize, packCount, variantId, mode);
      restorePackProgressIntoGrid();
    }
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    renderPackGrid();
    packModal.classList.add('is-open');
    document.body.classList.add('pack-grid-open');
  }

  function closePackGrid() {
    packModal.classList.remove('is-open');
    document.body.classList.remove('pack-grid-open');
    window.scrollTo(0, savedScrollY);
  }

  function customizeSlot(index, sharedLaunch) {
    if (index < 0 || index >= pack.size || !guardPackSlots(pack.unitSize, pack.packCount)) return;
    var existing = pack.slots[index];
    if (!sharedLaunch && !existing && !guardIndividualDesigns(pack.size)) return;
    var sourceDraftKey = !sharedLaunch && hasSharedDraft(index) ? existing.draftKey : '';
    var draftKey = sourceDraftKey ? makeDraftKey() : ((existing && existing.draftKey) ? existing.draftKey : makeDraftKey());
    pack.activeIndex = index;
    if (!sharedLaunch) {
      pack.quickMode = false;
      pack.designMode = 'individual';
    }
    // Full-page redirect wipes this page's JS state, so persist the
    // pack grid (which slots are already designed, which is active)
    // to sessionStorage. finalizeReturnFromDesigner() restores it.
    if (!savePackProgress()) {
      pack.activeIndex = -1;
      pack.quickMode = false;
      alert('Your browser blocked the temporary storage needed to keep this pack safe. No page was opened. Please allow site storage, then try again.');
      return;
    }
    openDesigner({
      draftKey: draftKey,
      packFlow: true,
      packSlot: index + 1,
      packMode: pack.mode,
      packUnitSize: pack.unitSize,
      packCount: pack.packCount,
      packTotal: pack.size,
      sourceDraftKey: sourceDraftKey,
      packDesignMode: sharedLaunch ? 'shared' : 'individual',
      packDesignCount: sharedLaunch ? pack.size : (existing ? 1 : pack.size)
    });
  }

  function captureSlotFromDesigner(data) {
    if (pack.activeIndex < 0) return false;
    var props = data && data.properties ? data.properties : {};
    var draftKey = props._draft_key || data.draftKey || activeDraftKey;
    if (!draftKey) return false;
    var captured = {
      draftKey: draftKey,
      previewUrl: props._preview_url || data.previewUrl || '',
      productionUrl: props._production_url || data.productionUrl || '',
      variantId: data.variantId || '',
      rawProperties: props
    };
    pack.slots[pack.activeIndex] = captured;

    if (pack.quickMode) {
      for (var i = 0; i < pack.size; i++) {
        if (i === pack.activeIndex) continue;
        pack.slots[i] = {
          draftKey: captured.draftKey,
          previewUrl: captured.previewUrl,
          productionUrl: captured.productionUrl,
          variantId: captured.variantId,
          rawProperties: captured.rawProperties
        };
      }
      pack.quickMode = false;
    }

    pack.activeIndex = -1;
    return true;
  }

  function appendEngravingProperties(properties, rawProperties, itemNumber) {
    if (!IS_ENGRAVING) return;
    Object.keys(rawProperties || {}).forEach(function (key) {
      var value = rawProperties[key];
      if (value === null || value === undefined || value === '') return;
      var target = itemNumber
        ? (key.charAt(0) === '_' ? '_design_' + itemNumber + key : 'Item ' + itemNumber + ' · ' + key)
        : key;
      properties[target] = String(value);
    });
  }

  function buildPackProperties(startIndex, count) {
    if (typeof startIndex !== 'number') startIndex = 0;
    if (typeof count !== 'number') count = pack.size;
    var properties = {};
    properties._pack_size = String(count);
    properties._pack_design_mode = pack.designMode;
    if (suiteKey) properties._customization_suite = suiteKey;
    if (modelKey) properties._customization_model = modelKey;
    if (printAreaWidth)  properties._print_area_width  = String(printAreaWidth);
    if (printAreaHeight) properties._print_area_height = String(printAreaHeight);
    if (printAreaUnit)   properties._print_area_unit   = String(printAreaUnit);

    var bundleSlots = bundleSlotsFor(pack.variantId || getCurrentVariantId());
    for (var i = 0; i < count; i++) {
      var slot = pack.slots[startIndex + i];
      if (!slot) continue;
      var n = i + 1;
      var slotMeta = bundleSlots ? bundleSlots[i % bundleSlots.length] : null;
      properties['Design ' + n] = slotMeta ? slotMeta.label : 'Item ' + n;
      if (slotMeta) {
        properties['_design_' + n + '_suite'] = slotMeta.suite;
        properties['_design_' + n + '_label'] = slotMeta.label;
      }
      properties['_design_' + n + '_draft_key'] = slot.draftKey || '';
      properties['_design_' + n + '_preview_url'] = slot.previewUrl || '';
      properties['_design_' + n + '_production_url'] = slot.productionUrl || '';
      appendEngravingProperties(properties, slot.rawProperties, n);
    }
    return properties;
  }

  function buildSlotProperties(slot) {
    var properties = {};
    if (pack.size > 1) properties._pack_design_mode = pack.designMode;
    if (suiteKey) properties._customization_suite = suiteKey;
    if (modelKey) properties._customization_model = modelKey;
    if (printAreaWidth)  properties._print_area_width  = String(printAreaWidth);
    if (printAreaHeight) properties._print_area_height = String(printAreaHeight);
    if (printAreaUnit)   properties._print_area_unit   = String(printAreaUnit);
    if (slot.draftKey)      properties._draft_key      = String(slot.draftKey);
    if (slot.previewUrl)    properties._preview_url    = String(slot.previewUrl);
    if (slot.productionUrl) properties._production_url = String(slot.productionUrl);
    appendEngravingProperties(properties, slot.rawProperties);
    return properties;
  }

  function submitPack() {
    if (packFilledCount() < pack.size) return;
    var variantId = pack.variantId || getCurrentVariantId();

    packSubmitBtn.disabled = true;
    var prevLabel = packSubmitBtn.textContent;
    packSubmitBtn.textContent = 'Adding…';

    var requestBody;
    if (pack.mode === 'multipack') {
      // Pack variant × qty: one line per pack, each with unitSize designs.
      // Shopify merges packs whose property bundles are identical.
      var items = [];
      for (var p = 0; p < pack.packCount; p++) {
        items.push({
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: normalizeProperties(buildPackProperties(p * pack.unitSize, pack.unitSize))
        });
      }
      requestBody = { items: items };
    } else if (pack.mode === 'multiqty') {
      // Non-pack × qty: N separate line items, qty 1 each. Shopify merges identicals.
      var items2 = [];
      for (var i = 0; i < pack.slots.length; i++) {
        var slot = pack.slots[i];
        if (!slot) continue;
        items2.push({
          id: parseInt(IS_ENGRAVING && slot.variantId || variantId, 10),
          quantity: 1,
          properties: normalizeProperties(buildSlotProperties(slot))
        });
      }
      requestBody = { items: items2 };
    } else {
      // Pack variant, qty 1: one line, all designs bundled.
      requestBody = {
        id: parseInt(variantId, 10),
        quantity: 1,
        properties: normalizeProperties(buildPackProperties(0, pack.size))
      };
    }

    fetch(route('/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(requestBody)
    })
    .then(function (r) {
      if (!r.ok) return parseCartAddError(r);
      return r.json();
    })
    .then(function () {
      clearPackProgress();
      closePackGrid();
      window.location.href = withPreviewParam(route('/cart'));
    })
    .catch(function (err) {
      packSubmitBtn.disabled = false;
      packSubmitBtn.textContent = prevLabel;
      alert('Could not add to cart: ' + (err && err.message ? err.message : 'Unknown error'));
    });
  }

  packTilesEl.addEventListener('click', function (e) {
    var actionEl = e.target.closest('[data-pack-action]');
    var tile = e.target.closest('[data-pack-slot]');
    if (!tile) return;
    var slotIndex = parseInt(tile.getAttribute('data-pack-slot'), 10);
    var action = actionEl ? actionEl.getAttribute('data-pack-action') : '';

    if (action === 'add' || action === 'edit') {
      closeAllCopyMenus();
      customizeSlot(slotIndex);
      return;
    }
    if (action === 'copy-toggle') {
      var menu = tile.querySelector('[data-copy-menu]');
      var willOpen = menu && menu.hidden;
      closeAllCopyMenus();
      if (willOpen) menu.hidden = false;
      return;
    }
    if (action === 'copy-to') {
      var target = actionEl.getAttribute('data-copy-target');
      copyDesignToTarget(slotIndex, target);
      return;
    }
    if (!action && !pack.slots[slotIndex]) {
      customizeSlot(slotIndex);
    }
  });
  packSubmitBtn.addEventListener('click', submitPack);
  packCloseBtn.addEventListener('click', closePackGrid);
  packQuickBtn.addEventListener('click', function () {
    if (packFilledCount()) {
      var sourceIndex = pack.slots.findIndex(function (slot) { return slot && slot.draftKey; });
      if (!confirm('Use item ' + (sourceIndex + 1) + '\'s design on all ' + pack.size + ' items? This will replace every other completed design.')) return;
      var source = pack.slots[sourceIndex];
      for (var i = 0; i < pack.size; i++) pack.slots[i] = Object.assign({}, source);
      pack.designMode = 'shared';
      pack.quickMode = false;
      savePackProgress();
      renderPackGrid();
      return;
    }
    pack.designMode = 'shared';
    pack.quickMode = true;
    customizeSlot(0, true);
  });
  packIndividualBtn.addEventListener('click', function () {
    if (!guardIndividualDesigns(pack.size)) return;
    pack.designMode = 'individual';
    pack.quickMode = false;
    savePackProgress();
    renderPackGrid();
  });
  packModal.addEventListener('click', function (e) {
    if (e.target === packModal) closePackGrid();
    else if (!e.target.closest('[data-pack-action="copy-toggle"]') && !e.target.closest('[data-copy-menu]')) {
      closeAllCopyMenus();
    }
  });

  if (openBtn) {
    openBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.openCustomDesigner();
    }, true);
  }

  // ===== "Add to cart, design later" =====
  // The relabelled Add-to-cart button adds the item(s) to the cart flagged as
  // needing a design, then opens the cart so the shopper can design each one
  // there (or leave it for later). Multi-unit / pack orders are split into one
  // line per unit so every unit can be designed individually — matching the
  // "Personalise now" flow. Pre-minted draft keys keep otherwise-identical
  // pending lines from being merged together by Shopify.
  function addDesignMeta(props) {
    props._design_status = 'pending';
    if (suiteKey) props._customization_suite = suiteKey;
    if (modelKey) props._customization_model = modelKey;
    if (printAreaWidth)  props._print_area_width  = String(printAreaWidth);
    if (printAreaHeight) props._print_area_height = String(printAreaHeight);
    if (printAreaUnit)   props._print_area_unit   = String(printAreaUnit);
    return props;
  }
  function buildPendingSingleProps() {
    var props = addDesignMeta({});
    props._draft_key = makeDraftKey();
    return props;
  }
  function buildPendingPackProps(unitSize) {
    var props = addDesignMeta({});
    props._pack_size = String(unitSize);
    var bundleSlots = bundleSlotsFor(getCurrentVariantId());
    for (var i = 1; i <= unitSize; i++) {
      props['_design_' + i + '_draft_key'] = makeDraftKey();
      var slotMeta = bundleSlots ? bundleSlots[(i - 1) % bundleSlots.length] : null;
      if (slotMeta) {
        props['Design ' + i] = slotMeta.label;
        props['_design_' + i + '_suite'] = slotMeta.suite;
        props['_design_' + i + '_label'] = slotMeta.label;
      }
    }
    return props;
  }
  var designLaterBusy = false;
  function addDesignLater(triggerBtn) {
    if (designLaterBusy) return;
    designLaterBusy = true;
    var variantId = getCurrentVariantId();
    var packN = packSizeFor(variantId);
    var qty = getQuantityValue();
    if (!guardPackSlots(packN, qty)) { designLaterBusy = false; return; }
    var vid = parseInt(variantId, 10);
    var requestBody;
    if (packN > 1 && qty > 1) {
      var mpItems = [];
      for (var p = 0; p < qty; p++) {
        var mpProps = buildPendingPackProps(packN);
        mpProps._pack_index = String(p + 1);
        mpItems.push({ id: vid, quantity: 1, properties: normalizeProperties(mpProps) });
      }
      requestBody = { items: mpItems };
    } else if (packN > 1) {
      requestBody = { id: vid, quantity: 1, properties: normalizeProperties(buildPendingPackProps(packN)) };
    } else if (qty > 1) {
      var mqItems = [];
      for (var q = 0; q < qty; q++) {
        mqItems.push({ id: vid, quantity: 1, properties: normalizeProperties(buildPendingSingleProps()) });
      }
      requestBody = { items: mqItems };
    } else {
      requestBody = { id: vid, quantity: 1, properties: normalizeProperties(buildPendingSingleProps()) };
    }

    var restoreBtn = null;
    if (triggerBtn) {
      var span = triggerBtn.querySelector('[data-atc-text]');
      var prevLabel = span ? span.textContent : '';
      triggerBtn.disabled = true;
      triggerBtn.classList.add('is-loading');
      restoreBtn = function () {
        triggerBtn.disabled = false;
        triggerBtn.classList.remove('is-loading');
        if (span) span.textContent = prevLabel;
      };
    }

    fetch(route('/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(requestBody)
    })
    .then(function (r) {
      if (!r.ok) return parseCartAddError(r);
      return r.json();
    })
    .then(function () {
      designLaterBusy = false;
      if (restoreBtn) restoreBtn();
      if (window.cartDrawer && typeof window.cartDrawer.open === 'function') {
        window.cartDrawer.open();
      } else {
        window.location.href = withPreviewParam(route('/cart'));
      }
    })
    .catch(function (err) {
      designLaterBusy = false;
      if (restoreBtn) restoreBtn();
      alert('Could not add to cart: ' + (err && err.message ? err.message : 'Unknown error'));
    });
  }

  // Intercept the product form submit (the relabelled "Add to cart, design
  // later" button). Capture phase + stopImmediatePropagation pre-empts the
  // theme-wide add-to-cart handler so the item lands with the pending flag.
  var designLaterBtn = document.querySelector('[data-add-to-cart][data-design-later]');
  var designLaterForm = designLaterBtn ? designLaterBtn.closest('form') : null;
  if (designLaterForm) {
    designLaterForm.addEventListener('submit', function (e) {
      // Only hijack the Add-to-cart submit — leave dynamic-checkout / express
      // payment buttons (Shop Pay, PayPal…) alone.
      if (e.submitter && !e.submitter.matches('[data-add-to-cart]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addDesignLater(designLaterForm.querySelector('[data-add-to-cart]'));
    }, true);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (packModal.classList.contains('is-open')) closePackGrid();
  });

  document.addEventListener('change', function (e) {
    if (!e.target) return;
    var el = e.target;
    var isVariantInput = el.name === 'id' || el.closest('[data-variant-select]');
    if (!isVariantInput) return;
    if (packModal.classList.contains('is-open')) {
      var newVariantId = getCurrentVariantId();
      var newPackN = packSizeFor(newVariantId);
      var newQty = getQuantityValue();
      var newUnit, newCount, newMode;
      if (newPackN > 1 && newQty > 1) { newUnit = newPackN; newCount = newQty; newMode = 'multipack'; }
      else if (newPackN > 1) { newUnit = newPackN; newCount = 1; newMode = 'pack'; }
      else if (newQty > 1) { newUnit = 1; newCount = newQty; newMode = 'multiqty'; }
      else { newUnit = 1; newCount = 1; newMode = pack.mode; }

      if (newUnit * newCount <= 1) {
        closePackGrid();
        return;
      }
      if (newUnit !== pack.unitSize || newCount !== pack.packCount
          || newVariantId !== pack.variantId || newMode !== pack.mode) {
        if (!guardPackSlots(newUnit, newCount)) return;
        resetPackState(newUnit, newCount, newVariantId, newMode);
        renderPackGrid();
      }
    }
  });

  // ===== Full-page redirect finalisation =====
  // Personalising navigates the whole tab to the Vercel designer,
  // which redirects back here with the finished asset URLs (cd_*
  // params). These helpers turn that return trip into a cart add /
  // update, carrying pack progress across the multiple round-trips a
  // multi-slot pack or mug+coaster bundle needs.
  var PACK_PROGRESS_KEY = 'cd_pack_progress:v1';
  // localStorage first so pack progress survives the browser
  // discarding the tab/session between designer round-trips
  // (common on mobile); sessionStorage stays as a fallback for
  // browsers where localStorage is blocked. Entries expire after
  // a day so an abandoned pack doesn't resurface weeks later.
  var PACK_PROGRESS_MAX_AGE_MS = 24 * 60 * 60 * 1000;
  function packProgressStores() {
    var stores = [];
    try { if (window.localStorage) stores.push(window.localStorage); } catch (e) { /* blocked */ }
    try { if (window.sessionStorage) stores.push(window.sessionStorage); } catch (e) { /* blocked */ }
    return stores;
  }
  function savePackProgress() {
    var serialized;
    try {
      serialized = JSON.stringify({
        savedAt: Date.now(),
        productId: productId,
        variantId: pack.variantId,
        mode: pack.mode,
        unitSize: pack.unitSize,
        packCount: pack.packCount,
        size: pack.size,
        quickMode: pack.quickMode,
        designMode: pack.designMode,
        activeIndex: pack.activeIndex,
        slots: pack.slots
      });
    } catch (e) {
      return false;
    }
    var stored = false;
    packProgressStores().forEach(function (store) {
      try {
        store.setItem(PACK_PROGRESS_KEY, serialized);
        if (store.getItem(PACK_PROGRESS_KEY) === serialized) stored = true;
      } catch (e) { /* quota/blocked — the other store may still work */ }
    });
    return stored;
  }
  function readRawPackProgress() {
    var stores = packProgressStores();
    for (var i = 0; i < stores.length; i++) {
      try {
        var raw = stores[i].getItem(PACK_PROGRESS_KEY);
        if (!raw) continue;
        var parsed = JSON.parse(raw);
        if (parsed && parsed.savedAt
            && Date.now() - Number(parsed.savedAt) > PACK_PROGRESS_MAX_AGE_MS) continue;
        return parsed;
      } catch (e) { /* corrupt entry — try the other store */ }
    }
    return null;
  }
  function readPackProgress(context) {
    return validatePackProgress(readRawPackProgress(), context);
  }
  function clearPackProgress() {
    packProgressStores().forEach(function (store) {
      try { store.removeItem(PACK_PROGRESS_KEY); } catch (e) { /* ignore */ }
    });
  }
  // A shopper who lost their tab/session mid-pack reopens the grid
  // with the slots they already designed instead of an empty grid.
  function restorePackProgressIntoGrid() {
    var stored = readRawPackProgress();
    if (!stored) return;
    var progress = validatePackProgress(stored, {
      variantId: String(pack.variantId || ''),
      mode: pack.mode,
      unitSize: pack.unitSize,
      packCount: pack.packCount,
      size: pack.size,
      activeIndex: Number(stored.activeIndex)
    });
    if (!progress) return;
    pack.slots = progress.slots.slice(0);
    pack.quickMode = progress.quickMode;
    pack.designMode = progress.designMode;
    pack.activeIndex = -1;
  }

  function positivePackInteger(value) {
    var stringValue = String(value === null || value === undefined ? '' : value);
    if (!/^[1-9]\d*$/.test(stringValue)) return 0;
    var parsed = Number(stringValue);
    if (!isFinite(parsed) || Math.floor(parsed) !== parsed || parsed > MAX_PACK_SLOTS) return 0;
    return parsed;
  }

  function packContextFromReturn(variantId) {
    var variantKey = String(variantId || '');
    var mode = pageParams.get('cd_ctx_pack_mode') || '';
    var unitSize = positivePackInteger(pageParams.get('cd_ctx_pack_unit_size'));
    var packCount = positivePackInteger(pageParams.get('cd_ctx_pack_count'));
    var size = positivePackInteger(pageParams.get('cd_ctx_pack_total'));
    var slot = positivePackInteger(pageParams.get('cd_ctx_pack_slot'));
    var expectedUnitSize = packSizeFor(variantKey);

    if (!getVariantEntry(variantKey)) return null;
    if (mode !== 'pack' && mode !== 'multiqty' && mode !== 'multipack') return null;
    if (!unitSize || !packCount || !size || !slot) return null;
    if (size !== unitSize * packCount || slot > size) return null;
    if (mode === 'pack' && (expectedUnitSize <= 1 || unitSize !== expectedUnitSize || packCount !== 1)) return null;
    if (mode === 'multiqty' && (expectedUnitSize !== 1 || unitSize !== 1 || packCount <= 1)) return null;
    if (mode === 'multipack' && (expectedUnitSize <= 1 || unitSize !== expectedUnitSize || packCount <= 1)) return null;

    return {
      variantId: variantKey,
      mode: mode,
      unitSize: unitSize,
      packCount: packCount,
      size: size,
      activeIndex: slot - 1
    };
  }

  function normalizePackSlot(slot) {
    if (!slot || typeof slot !== 'object') return null;
    var draftKey = typeof slot.draftKey === 'string' ? slot.draftKey : '';
    var previewUrl = typeof slot.previewUrl === 'string' ? slot.previewUrl : '';
    var productionUrl = typeof slot.productionUrl === 'string' ? slot.productionUrl : '';
    if (!draftKey || (!previewUrl && !productionUrl)) return null;
    return {
      draftKey: draftKey,
      previewUrl: previewUrl,
      productionUrl: productionUrl,
      variantId: typeof slot.variantId === 'string' ? slot.variantId : '',
      rawProperties: slot.rawProperties && typeof slot.rawProperties === 'object' ? slot.rawProperties : {}
    };
  }

  function validatePackProgress(progress, context) {
    if (!progress || typeof progress !== 'object' || !context) return null;
    if (String(progress.productId || '') !== String(productId)) return null;
    if (String(progress.variantId || '') !== context.variantId) return null;
    if (progress.mode !== context.mode) return null;
    if (positivePackInteger(progress.unitSize) !== context.unitSize) return null;
    if (positivePackInteger(progress.packCount) !== context.packCount) return null;
    if (positivePackInteger(progress.size) !== context.size) return null;
    if (Number(progress.activeIndex) !== context.activeIndex) return null;
    if (!Array.isArray(progress.slots)) return null;

    var slots = [];
    for (var i = 0; i < context.size; i++) {
      slots.push(normalizePackSlot(progress.slots[i]));
    }
    return {
      productId: productId,
      variantId: context.variantId,
      mode: context.mode,
      unitSize: context.unitSize,
      packCount: context.packCount,
      size: context.size,
      quickMode: progress.quickMode === true,
      designMode: progress.designMode === 'shared' || progress.quickMode === true ? 'shared' : 'individual',
      activeIndex: context.activeIndex,
      slots: slots
    };
  }

  function reconstructPackProgress(context) {
    var slots = [];
    for (var i = 0; i < context.size; i++) slots.push(null);
    return {
      productId: productId,
      variantId: context.variantId,
      mode: context.mode,
      unitSize: context.unitSize,
      packCount: context.packCount,
      size: context.size,
      quickMode: false,
      designMode: 'individual',
      activeIndex: context.activeIndex,
      slots: slots
    };
  }

  function designFromReturnParams() {
    var productionUrl = pageParams.get('cd_production_url') || '';
    var previewUrl = pageParams.get('cd_preview_url') || '';
    if (!productionUrl && !previewUrl) return null;
    var extraProps = {};
    try {
      var rawProps = pageParams.get('cd_props');
      if (rawProps) {
        var parsedProps = JSON.parse(rawProps);
        if (parsedProps && typeof parsedProps === 'object') extraProps = parsedProps;
      }
    } catch (e) { extraProps = {}; }
    return {
      draftKey: pageParams.get('cd_ctx_draft_key') || pageParams.get('cd_draft_key') || '',
      designId: pageParams.get('cd_design_id') || '',
      previewUrl: previewUrl,
      productionUrl: productionUrl,
      text: pageParams.get('cd_text') || '',
      photos: pageParams.get('cd_photos') || '',
      adminOrderId: pageParams.get('cd_admin_order_id') || '',
      // Engraved products: Finish, each engraving line, charm names…
      props: extraProps,
      variantId: pageParams.get('cd_variant_id') || ''
    };
  }

  function clearReturnParams() {
    ['cd_return','cd_ctx_variant','cd_ctx_draft_key','cd_ctx_original_draft_key','cd_ctx_line_key',
     'cd_ctx_pack_slot','cd_ctx_pack','cd_preview_url','cd_production_url',
     'cd_ctx_pack_mode','cd_ctx_pack_unit_size','cd_ctx_pack_count','cd_ctx_pack_total',
     'cd_design_id','cd_draft_key','cd_text','cd_photos','cd_admin_order_id',
     'cd_props','cd_variant_id'
    ].forEach(function (k) { pageParams.delete(k); });
    var nextSearch = pageParams.toString();
    window.history.replaceState({}, '', pageUrl.pathname + (nextSearch ? '?' + nextSearch : '') + pageUrl.hash);
  }

  var returnOverlayEl = null;
  function showReturnOverlay(text) {
    if (!returnOverlayEl) {
      var style = document.createElement('style');
      style.textContent =
        '.cd-return-overlay{position:fixed;inset:0;z-index:100000;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,0.94);}'
        + '.cd-return-overlay__card{text-align:center;font-family:inherit;color:#222;}'
        + '.cd-return-overlay__spinner{width:38px;height:38px;margin:0 auto 14px;border:3px solid #d4dbe5;border-top-color:#1f70ff;border-radius:50%;animation:cd-spin 0.8s linear infinite;}'
        + '.cd-return-overlay__text{font-size:1rem;font-weight:600;margin:0;}'
        + '@keyframes cd-spin{to{transform:rotate(360deg);}}';
      document.head.appendChild(style);
      returnOverlayEl = document.createElement('div');
      returnOverlayEl.className = 'cd-return-overlay';
      returnOverlayEl.innerHTML = '<div class="cd-return-overlay__card"><div class="cd-return-overlay__spinner"></div><p class="cd-return-overlay__text"></p></div>';
      document.body.appendChild(returnOverlayEl);
    }
    returnOverlayEl.querySelector('.cd-return-overlay__text').textContent = text || 'Working…';
    returnOverlayEl.style.display = 'flex';
  }
  function hideReturnOverlay() { if (returnOverlayEl) returnOverlayEl.style.display = 'none'; }
  function returnError(err) {
    hideReturnOverlay();
    var msg = err && err.message ? err.message : 'Something went wrong.';
    alert('Could not add your design to the cart: ' + msg + '\n\nPlease try personalising again.');
  }

  function addSingleDesignToCart(variantId, design) {
    var properties = {};
    if (design.designId)     properties._design_id      = design.designId;
    if (design.draftKey)     properties._draft_key      = design.draftKey;
    if (design.previewUrl)   properties._preview_url     = design.previewUrl;
    if (design.productionUrl) properties._production_url = design.productionUrl;
    if (design.adminOrderId) properties._admin_order_id = design.adminOrderId;
    if (design.text)         properties['Custom text']  = design.text;
    if (design.photos && design.photos !== '0') properties['Photos'] = design.photos;
    if (design.props) {
      Object.keys(design.props).forEach(function (key) {
        if (design.props[key]) properties[key] = String(design.props[key]);
      });
    }
    var effSuite = effectiveSuiteFor(variantId);
    var effDims = effectiveDimsFor(variantId);
    if (effSuite) properties._customization_suite = effSuite;
    if (modelKey) properties._customization_model = modelKey;
    if (effDims.w) properties._print_area_width  = String(effDims.w);
    if (effDims.h) properties._print_area_height = String(effDims.h);
    if (effDims.u) properties._print_area_unit   = String(effDims.u);
    var addVariantId = parseInt(design.variantId || variantId, 10);
    return fetch(route('/cart/add.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: addVariantId, quantity: 1, properties: normalizeProperties(properties) })
    }).then(function (r) { if (!r.ok) return parseCartAddError(r); return r.json(); });
  }

  // Update an existing cart line (single line or one slot of a pack)
  // with a freshly-designed asset. Mirrors the pack-edit merge logic.
  function applyCartEditDesign(editLineKey, editSlot, design, originalDraftKey) {
    var draftKeyHint = originalDraftKey || design.draftKey || '';
    return fetch(route('/cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var line = items.find(function (it) { return it.key === editLineKey; });
        if (!line) {
          var variantIdNum = parseInt(getCurrentVariantId(), 10);
          var matches = items.filter(function (it) {
            if (it.variant_id !== variantIdNum || !it.properties) return false;
            if (editSlot > 0) {
              if (!it.properties._pack_size) return false;
              return draftKeyHint && it.properties['_design_' + editSlot + '_draft_key'] === draftKeyHint;
            }
            return draftKeyHint && it.properties._draft_key === draftKeyHint;
          });
          line = matches.length === 1 ? matches[0] : null;
          if (line) editLineKey = line.key;
        }
        if (!line) throw new Error('That cart item could not be found. Please return to the cart and try again.');
        var merged = {};
        Object.keys(line.properties || {}).forEach(function (key) {
          var v = line.properties[key];
          if (v !== null && v !== undefined && v !== '') merged[key] = String(v);
        });
        var n = editSlot;
        if (n > 0) {
          if (IS_ENGRAVING) {
            Object.keys(merged).forEach(function (key) {
              if (key.indexOf('_design_' + n + '_') === 0 || key.indexOf('Item ' + n + ' · ') === 0) delete merged[key];
            });
            appendEngravingProperties(merged, design.props, n);
          }
          merged._pack_design_mode = 'individual';
          if (design.draftKey)      merged['_design_' + n + '_draft_key']      = String(design.draftKey);
          if (design.previewUrl)    merged['_design_' + n + '_preview_url']    = String(design.previewUrl);
          if (design.productionUrl) merged['_design_' + n + '_production_url'] = String(design.productionUrl);
          var packTotal = parseInt(merged._pack_size || '0', 10);
          if (packTotal > 0) {
            var filledSlots = 0;
            for (var s = 1; s <= packTotal; s++) {
              if (merged['_design_' + s + '_preview_url'] || merged['_design_' + s + '_production_url']) filledSlots++;
            }
            if (filledSlots >= packTotal) delete merged._design_status;
          }
        } else {
          if (design.draftKey)      merged._draft_key      = String(design.draftKey);
          if (design.previewUrl)    merged._preview_url    = String(design.previewUrl);
          if (design.productionUrl) merged._production_url  = String(design.productionUrl);
          if (design.text)          merged['Custom text']  = String(design.text);
          if (design.props) {
            Object.keys(design.props).forEach(function (key) {
              if (design.props[key]) merged[key] = String(design.props[key]);
            });
          }
          delete merged._design_status;
        }
        // Engraved products let the shopper change the FINISH inside
        // the designer, and a finish is a different variant.
        // /cart/change.js cannot swap a variant, so drop the old line
        // and add the chosen one carrying the merged properties.
        var newVariantId = parseInt(design.variantId || '0', 10);
        if (newVariantId && newVariantId !== line.variant_id) {
          return fetch(route('/cart/change.js'), {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: editLineKey, quantity: 0 })
          }).then(function (removed) {
            if (!removed || !removed.ok) return parseCartAddError(removed);
            return fetch(route('/cart/add.js'), {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                id: newVariantId,
                quantity: line.quantity || 1,
                properties: normalizeProperties(merged)
              })
            });
          });
        }
        return fetch(route('/cart/change.js'), {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: editLineKey, properties: merged })
        });
      })
      .then(function (r) { if (!r || !r.ok) return parseCartAddError(r); return null; });
  }

  // Restore the pack grid saved before a slot redirect and re-show it.
  function reopenPackFromProgress(progress) {
    pack.variantId = progress.variantId;
    pack.mode = progress.mode;
    pack.unitSize = progress.unitSize;
    pack.packCount = progress.packCount;
    pack.size = progress.size;
    pack.slots = progress.slots.slice(0);
    pack.activeIndex = -1;
    pack.quickMode = progress.quickMode;
    pack.designMode = progress.designMode;
    if (progress.variantId) syncVariantSelection(String(progress.variantId));
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    renderPackGrid();
    packModal.classList.add('is-open');
    document.body.classList.add('pack-grid-open');
  }

  function finalizeReturnFromDesigner() {
    if (pageParams.get('cd_return') !== '1') return;
    var design = designFromReturnParams();
    var ctxVariantParam = pageParams.get('cd_ctx_variant') || '';
    var ctxLineKey = pageParams.get('cd_ctx_line_key') || '';
    var ctxOriginalDraftKey = pageParams.get('cd_ctx_original_draft_key') || '';
    var ctxPackSlot = parseInt(pageParams.get('cd_ctx_pack_slot') || '0', 10);
    var isPackFlow = pageParams.get('cd_ctx_pack') === '1';
    var packContext = isPackFlow ? packContextFromReturn(ctxVariantParam) : null;

    // Strip the params first so a refresh / back button can't re-add.
    clearReturnParams();

    if (!design) {
      // Returned with no artwork (cancelled from the designer).
      clearPackProgress();
      return;
    }

    // 1) Editing an existing cart line (single line or pack slot).
    if (ctxLineKey) {
      showReturnOverlay('Saving your design…');
      applyCartEditDesign(ctxLineKey, ctxPackSlot, design, ctxOriginalDraftKey)
        .then(function () { window.location.href = withPreviewParam(route('/cart')); })
        .catch(returnError);
      return;
    }

    // 2) Pack / bundle: capture this slot, resume the grid or submit.
    if (isPackFlow) {
      if (!packContext) {
        clearPackProgress();
        returnError(new Error('The pack return details were incomplete or invalid.'));
        return;
      }
      var progress = readPackProgress(packContext);
      if (!progress) {
        clearPackProgress();
        progress = reconstructPackProgress(packContext);
      }
      reopenPackFromProgress(progress);
      pack.activeIndex = packContext.activeIndex;
      pack.quickMode = !!progress.quickMode;
      var captured = captureSlotFromDesigner({
        draftKey: design.draftKey,
        previewUrl: design.previewUrl,
        productionUrl: design.productionUrl,
        variantId: design.variantId,
        properties: Object.assign({}, design.props || {}, {
          _draft_key: design.draftKey,
          _preview_url: design.previewUrl,
          _production_url: design.productionUrl
        })
      });
      if (!captured) {
        returnError(new Error('The returned pack design was missing its draft details.'));
        return;
      }
      savePackProgress();
      if (packFilledCount() >= pack.size) {
        submitPack();
      } else {
        renderPackGrid();
      }
      return;
    }

    // 3) Fresh single-item designs return through /cart, not this
    // product-page dispatcher. Failing closed here prevents a
    // damaged pack return from ever becoming a plain pack-SKU line.
    clearPackProgress();
    returnError(new Error('The design return details were incomplete or invalid.'));
  }

  finalizeReturnFromDesigner();

  if (pageParams.get('variant')) {
    syncVariantSelection(pageParams.get('variant'));
  }

  if (pageParams.get('customize') === '1') {
    var paramPackSlot = parseInt(pageParams.get('pack_slot') || '0', 10);
    var paramLineKey = pageParams.get('line_key') || '';
    // line_key + pack_slot => editing one slot of a pack line.
    // line_key alone   => editing (or first-designing) a single line in the cart.
    if (paramLineKey) {
      cartEdit.active = true;
      cartEdit.lineKey = paramLineKey;
      cartEdit.slot = paramPackSlot > 0 ? paramPackSlot : 0;
    }
    window.setTimeout(function () {
      if (pageParams.get('variant')) {
        syncVariantSelection(pageParams.get('variant'));
      }
      // A bundle needs a slot to know which suite to open. Without one
      // (e.g. a stale link), show the pack grid instead of the designer.
      if (IS_BUNDLE && !(cartEdit.active && cartEdit.slot > 0)) {
        var autoVariantId = getCurrentVariantId();
        openPackGrid(autoVariantId, packSizeFor(autoVariantId), 1, 'pack');
        clearAutoOpenParam();
        return;
      }
      var requestedDraftKey = pageParams.get('draft_key') || makeDraftKey();
      if (cartEdit.active && cartEdit.slot > 0) {
        fetch(route('/cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) return parseCartAddError(r); return r.json(); })
          .then(function (cart) {
            var line = (cart.items || []).find(function (item) { return item.key === cartEdit.lineKey; });
            if (!line) throw new Error('That cart item could not be found. Please return to the cart and try again.');
            var props = line.properties || {};
            var hasSlotDesign = props['_design_' + cartEdit.slot + '_preview_url'] || props['_design_' + cartEdit.slot + '_production_url'];
            if (!hasSlotDesign && !guardIndividualDesigns(Number(props._pack_size || 0))) {
              clearAutoOpenParam();
              return;
            }
            var selectedKey = props['_design_' + cartEdit.slot + '_draft_key'] || requestedDraftKey;
            var duplicate = false;
            for (var i = 1; i <= Number(props._pack_size || 0); i++) {
              if (i !== cartEdit.slot && props['_design_' + i + '_draft_key'] === selectedKey) duplicate = true;
            }
            openDesigner({
              draftKey: duplicate ? makeDraftKey() : selectedKey,
              sourceDraftKey: duplicate ? selectedKey : '',
              originalDraftKey: selectedKey,
              packDesignCount: 1
            });
            clearAutoOpenParam();
          })
          .catch(returnError);
        return;
      }
      openDesigner({ draftKey: requestedDraftKey });
      clearAutoOpenParam();
    }, 120);
  }
})();
